import {SMART_SEARCH_KEY} from '../../constants/smartSearchKey';
import {EagGridState} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

const selectSmartSearchValue = (state: EagGridState): string => {
  const rawFilterState = state.filterValues?.[SMART_SEARCH_KEY];
  if (rawFilterState != null && typeof rawFilterState[SMART_SEARCH_KEY] === 'string') {
    return rawFilterState[SMART_SEARCH_KEY] as string;
  }
  return '';
};

/**
 * Fine-grained selector — only triggers re-render when the smart search input value changes.
 * Components that only display/edit the smart search field should use this instead of
 * subscribing to the entire filterValues object.
 */
export function useSmartSearchFilter(): string {
  return useEagGridSelector(selectSmartSearchValue);
}
